import React, { useState, useRef } from 'react';
import { CommandBarButton,Callout, mergeStyleSets } from '@fluentui/react';

const classNames = mergeStyleSets({
  root: {
    display: 'flex',
  },
  callout: {
    maxWidth: 300,
    padding: 20,
  },
})

const WhiteCommandBarButton = ({ onClick, callout, ...restProps }) => {
  const targetButton = useRef(null);
  const [isCalloutOpen, setCalloutOpen] = useState(false);

  return (
    <>
      <div className={classNames.root} ref={targetButton}>
        <CommandBarButton {...restProps}
          onClick={() => callout ? setCalloutOpen(true) : onClick()}
          styles={{
            ...restProps.styles,
            root: { backgroundColor: 'white' },
            rootDisabled: { backgroundColor: 'white' },
          }}
        />
      </div>
      { isCalloutOpen && <Callout
          className={classNames.callout}
          role="alertdialog"
          gapSpace={0}
          target={targetButton}
          onDismiss={() => setCalloutOpen(false)}
          setInitialFocus
          >
        {callout}
      </Callout>
    }
    </>
  );
}

export default WhiteCommandBarButton;